export enum IntakeFormSections {
  USER = 'USER',
  ORGANIZATION = 'ORGANIZATION',
  PLAINTIFF = 'PLAINTIFF',
  TENANT = 'TENANT',
  EVICTION_REASON = 'EVICTION_REASON',
  PROPERTY = 'PROPERTY',
  LEASE_TERMS = 'LEASE_TERMS',
  CLAIMS = 'CLAIMS',
  INTERNAL = 'INTERNAL',
  OTHER = 'OTHER',
  DOCUMENTS = 'DOCUMENTS'
}
